import { render, staticRenderFns } from "./Invoicemangerdetail.vue?vue&type=template&id=dae7d1e0&scoped=true&"
import script from "./Invoicemangerdetail.vue?vue&type=script&lang=js&"
export * from "./Invoicemangerdetail.vue?vue&type=script&lang=js&"
import style0 from "./Invoicemangerdetail.vue?vue&type=style&index=0&id=dae7d1e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae7d1e0",
  null
  
)

export default component.exports